// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewDescriptionModal_modal__kDB1t{
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 400;
}
.ViewDescriptionModal_container__dqbtb{
    position: relative;
    height: 90%;
    width: 85%;
    max-width: 412px;
    padding: 20px;
    background-color: #FFFFFF;
    border: 1px solid #1F363D1A;
    border-radius: 25px;
    box-shadow: 0 3px 12px 0 #00000012;
}
.ViewDescriptionModal_close__oyYfw{
    position: absolute;
    top: 28px;
    right: 33px;
    height: 12px;
    width: 12px;
    cursor: pointer;
}
.ViewDescriptionModal_description__HVDlt{
    height: calc(100% - 100px);
    margin: 20px;
    white-space: pre-wrap;
    overflow-y: auto;
}
.ViewDescriptionModal_button__mcdBZ{
    width: 194px;
    margin: 30px auto 0 auto;
    padding-left: 50px;
    padding-right: 50px;
}`, "",{"version":3,"sources":["webpack://./src/components/modals/ViewDescriptionModal.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,oCAAoC;IACpC,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,2BAA2B;IAC3B,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;AACA;IACI,0BAA0B;IAC1B,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;AACvB","sourcesContent":[".modal{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 400;\n}\n.container{\n    position: relative;\n    height: 90%;\n    width: 85%;\n    max-width: 412px;\n    padding: 20px;\n    background-color: #FFFFFF;\n    border: 1px solid #1F363D1A;\n    border-radius: 25px;\n    box-shadow: 0 3px 12px 0 #00000012;\n}\n.close{\n    position: absolute;\n    top: 28px;\n    right: 33px;\n    height: 12px;\n    width: 12px;\n    cursor: pointer;\n}\n.description{\n    height: calc(100% - 100px);\n    margin: 20px;\n    white-space: pre-wrap;\n    overflow-y: auto;\n}\n.button{\n    width: 194px;\n    margin: 30px auto 0 auto;\n    padding-left: 50px;\n    padding-right: 50px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `ViewDescriptionModal_modal__kDB1t`,
	"container": `ViewDescriptionModal_container__dqbtb`,
	"close": `ViewDescriptionModal_close__oyYfw`,
	"description": `ViewDescriptionModal_description__HVDlt`,
	"button": `ViewDescriptionModal_button__mcdBZ`
};
export default ___CSS_LOADER_EXPORT___;
